import { gtmOnclick } from "./gtmOnclick";

export const gtmOnclickNotasImportantes = () => {
  gtmOnclick({
    subZona: "Simulación",
    seccion: "Notas Importantes",
    tipoEvento: "Visualizar",
    tipoElemento: "Modal",
    valor: "Notas Importantes",
  });
};

export const gtmOnclickConoceTuCobertura = () => {
  gtmOnclick({
    subZona: "Simulación",
    seccion: "Conoce tu cobertura aquí",
    tipoEvento: "Clic",
    tipoElemento: "Enlace",
    valor: "Conoce tu cobertura aquí",
  });
};

export const gtmOnclickConfirmarDatosOpen = (pageTitle) => {
  gtmOnclick({
    subZona: pageTitle,
    seccion: "Hablar con un asesor",
    tipoEvento: "Visualizar",
    tipoElemento: "Modal",
    valor: "Hablar con un asesor",
  });
};

export const gtmOnclickConfirmarDatosContinuar = (pageTitle) => {
  gtmOnclick({
    subZona: pageTitle,
    seccion: "Hablar con un asesor - Modal",
    tipoEvento: "Clic",
    tipoElemento: "Botón",
    valor: "Continuar",
  });
};